<template>
  <div class="flex flex-col h-full" v-loading.fullscreen="loading">
    <el-card class="m-5">
      <template #header>
        <div class="flex justify-between items-center">
          <span class="text-lg font-bold">{{ $t('serial_detail') }}</span>
          <div>
            <el-button @click="goBack">
              <span class="mr-2">←</span>
              {{ $t('back') }}
            </el-button>
          </div>
        </div>
      </template>
      <div v-if="serial" class="flex flex-col">
        <span class="font-bold mb-4">{{ $t('serial_code') }}: {{ serial.code }}</span>

        <span class="font-bold mb-4 mt-6">
          {{ $t('serial_histories') }}
        </span>
        <el-table
          class="table-content rounded-xl w-full"
          ref="tableSerialHistoriesRef"
          :data="serial.serialHistories || []"
          header-cell-class-name="custom-table__header-cell"
          cell-class-name="custom-table__cell "
          border
          :empty-text="$t('empty')"
          highlight-current-row
        >
          <el-table-column :label="$t('manufacture_order_number')" prop="orderNumber"></el-table-column>
          <el-table-column :label="$t('item_code')" prop="itemCode"></el-table-column>
          <el-table-column :label="$t('operator_type')">
            <template #default="{ row }">
              <span>{{ getOperatorTypeLabel(row.operatorType) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('machine_code')" prop="machineCode"></el-table-column>
          <el-table-column :label="$t('amount')">
            <template #default="{ row }">
              <span>{{ row.amount }}</span>
              <span>({{ row.unit }})</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('manufacturing_date')">
            <template #default="{ row }">
              <span>{{ formatTime(row.scannedDateTime) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script lang="ts">
import { FETCH_SERIAL_DETAIL } from '@/store/actions'
import errorHandler from '@/utils/errorHandler'
import { formatTimestamp } from '@/utils/timeUtils'
import { ISerial, OperatorType } from '@/utils/types/model/serial'
import { Options, Vue } from 'vue-class-component'

@Options({
  name: 'SerialDetail',
})
export default class SerialDetail extends Vue {
  loading = false

  formatTime(dateStr: string): string {
    return formatTimestamp(dateStr)
  }

  getOperatorTypeLabel(operatorType: OperatorType): string {
    return this.$t(`operator_type_${operatorType}`)
  }

  get serialCode(): string {
    return this.$route.params.id as string
  }

  get serial(): ISerial | null {
    return this.$store.getters.getSerialDetail
  }

  async fetchDetail() {
    try {
      this.loading = true
      await this.$store.dispatch(FETCH_SERIAL_DETAIL, this.serialCode)
    } catch (error) {
      errorHandler(error, {}, true)
    } finally {
      this.loading = false
    }
  }

  goBack() {
    this.$router.back()
  }

  mounted() {
    this.fetchDetail()
  }
}
</script>

<style scoped>
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
